import { useEffect } from "react";

// const themeInfo = {
//   primaryColor: "#0f5bf1",
//   secondaryColor: "#006EFF",
//   accentColors: ["#0f5bf1", "#4B8DF8", "#2133AF"],
//   warningColor: "#ff595e",
//   fontName: "Inter, sans-serif",
//   fontUrl: "https://fonts.googleapis.com/css2?family=Inter&display=swap",
//   fontSize: "20px",
//   color: "#ffffff",
// };

interface ConveraWidgetWrapperProps {
  sellerInfo: any; 
}

const ConveraWidgetWrapper = ({
  sellerInfo
}: ConveraWidgetWrapperProps) => {
  useEffect(() => {
    const container = document.getElementById("converaPaymentContainer");

    let finalSellerInfo = sellerInfo;
    
    // if (!sellerInfo && clientId && merchantId && merchantSecret) {
    //   const info = {
    //     paymentInformation: {
    //       clientId,
    //       merchantId,
    //       merchantSecret,
    //       buyer: { country }
    //     }
    //   };
    //   finalSellerInfo = JSON.stringify(info).replace(/"/g, "&quot;");
    // }

    // const dataTheme = JSON.stringify(themeInfo).replace(/"/g, "&quot;");

    if (container && finalSellerInfo) {
      container.innerHTML = `<convera-payment data-seller-info='${finalSellerInfo}''></convera-payment>`;
    }
  }, [sellerInfo]);

  return <div id="converaPaymentContainer" style={{width: "100%"}} />;
};

export default ConveraWidgetWrapper;
